import { createBrowserRouter } from 'react-router-dom';

import DocuSignAuthenticated from 'features/elements/Authentication/DocuSignAuthenticated';
import CampaignsViewPage from 'features/elements/CampaignsView/CampaignsViewPage';
import ReportingDashboard from 'features/reportingDashboard/reportingDashboard';
import BrandedLayout from 'layout/BrandedLayout';
import ValidateAccessLayout from 'layout/ValidateAccessLayout';
import RPDataAuthenticated from './features/elements/Authentication/RpDataAuthenticated';
import AuthenticatedLayout from './layout/AuthenticatedLayout';
import Form from 'features/form/form';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthenticatedLayout />,
    children: [
      {
        path: '/',
        element: (
          <ValidateAccessLayout>
            <BrandedLayout>
              <CampaignsViewPage />
            </BrandedLayout>
          </ValidateAccessLayout>
        ),
      },
      {
        path: '/form',
        element: <Form />,
      },
      {
        path: '/rpdata/authenticated',
        element: <RPDataAuthenticated />,
      },
      {
        path: '/docusign/authenticated',
        element: <DocuSignAuthenticated />,
      },
      {
        path: '/dashboard',
        element: (
          <BrandedLayout>
            <ReportingDashboard />
          </BrandedLayout>
        ),
      },
    ],
  },
]);

export default router;
